'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaPrint = function FaPrint(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10.1 34.3h20v-5.7h-20v5.7z m0-14.3h20v-8.6h-3.6q-0.9 0-1.5-0.6t-0.6-1.5v-3.6h-14.3v14.3z m25.7 1.4q0-0.5-0.4-1t-1-0.4-1 0.4-0.5 1 0.5 1 1 0.5 1-0.5 0.4-1z m2.8 0v9.3q0 0.3-0.2 0.5t-0.5 0.2h-5v3.6q0 0.9-0.6 1.5t-1.5 0.6h-21.4q-0.9 0-1.6-0.6t-0.6-1.5v-3.6h-5q-0.3 0-0.5-0.2t-0.2-0.5v-9.3q0-1.7 1.3-3t3-1.3h1.4v-12.1q0-0.9 0.6-1.5t1.6-0.6h15q0.9 0 1.9 0.4t1.7 1.1l3.4 3.4q0.6 0.6 1.1 1.7t0.4 1.9v5.7h1.5q1.7 0 3 1.3t1.2 3z' })
        )
    );
};

exports.default = FaPrint;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/print.js
// module id = 1916
// module chunks = 168707334958949